import { Alert, Box, Card, CircularProgress, Typography } from '@mui/material';
import React from 'react';

import { useApiData } from '../../hooks/useApiData';

const isForbidden = (err: Error | null) =>
  (err as any)?.response?.status === 403;

const AttendanceCard: React.FC = () => {
  const {
    data: clockUrl,
    error: clockError,
    loading: clockLoading,
  } = useApiData<string>((api) => api.attendance.getClockRedirect());

  if (!clockLoading && isForbidden(clockError)) {
    return null;
  }

  if (!clockLoading && (clockError || !clockUrl)) {
    return (
      <Alert severity="error">
        An error occured while loading the attendance page. Please refresh and
        try again
      </Alert>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: 3,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5">Time & attendance</Typography>
      </Box>
      {clockLoading ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        clockUrl && (
          <Box
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid #f1f3f4',
            }}
          >
            <iframe
              src={clockUrl}
              title="SwipeClock"
              style={{
                width: '100%',
                height: 340,
                border: 'none',
                display: 'block',
              }}
            />
          </Box>
        )
      )}
    </Card>
  );
};

export default AttendanceCard;
